export class BorderModel {
  public id: number;
  public name: string;
  public country: string;
  public addressLine1: string;
  public addressLine2: string;
  public addressLine3 : string;
  public contactNo: number;
  public email: string;
  public fax: string;
  public status: string;
  public lastUpdatedUser: string;
  public url: string;

  constructor(id: number , name: string ,country: string, addressLine1: string, addressLine2: string, addressLine3: string, contactNo: number, email: string, fax: string, status: string, lastUpdatedUser: string , url: string) {
   this.id = id;
   this.name = name;
   this.country = country;
   this.addressLine1 = addressLine1;
   this.addressLine2 = addressLine2;
   this.addressLine3 = addressLine3;
   this.contactNo = contactNo;
   this.email = email;
   this.fax = fax;
   this.status = status;
   this.lastUpdatedUser = lastUpdatedUser;
   this.url = url;
  }
}
